export default __webpack_public_path__ + "images/OW.a0dd503.png";